/**
 * Warwick Design System - Layout Tokens
 * Screen dimensions, component sizes, and layout-related values
 * All sizes converted from pixels to rem (16px = 1rem)
 */

// Screen dimensions (for reference - actual implementation should be responsive)
export const screen = {
  design: {
    width: '120rem', // 1920px - Design reference width
    height: '67.5rem', // 1080px - Design reference height
  },
};

// Component dimensions
export const dimensions = {
  // Header
  headerBar: {
    height: '7.9375rem', // 127px
  },

  // Sidebar
  leftSidebar: {
    width: '23.3125rem', // 373px
    percentage: '20%', // As currently used in styles
  },

  // Icons and elements
  icons: {
    nav: {
      size: '2rem', // 32x32px navigation icons
    },
    avatar: {
      size: '3rem', // 48x48px avatar
    },
    wifi: {
      width: '3.5rem', // 56px wifi icon width
      height: '2.25rem', // 36px wifi icon height
    },
    qrCode: {
      size: '8.9375rem', // 143x143px QR code
    },
  },

  // Navigation
  bottomNav: {
    button: {
      size: '3.5rem', // Navigation button container size
    },
    container: {
      // Base dimensions - should be dynamic based on content
      baseWidth: '19.3125rem', // 309px
      height: '4.3125rem', // 69px
      borderRadius: '4.164375rem', // 66.63px
    },
  },

  // Cards
  serviceCard: {
    minHeight: '18.75rem', // 300px minimum height
    width: '33.333%', // Current carousel width
  },
};

// Layout patterns
export const layout = {
  // Flex patterns
  flex: {
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    centerVertical: {
      display: 'flex',
      alignItems: 'center',
    },
    spaceBetween: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
    },
  },

  // Container patterns
  container: {
    fullScreen: {},
    sidebar: {
      display: 'flex',
      flexDirection: 'column',
      width: dimensions.leftSidebar.percentage,
      flexShrink: 0,
    },
    carousel: {},
  },

  // Positioning
  position: {
    absolute: {
      position: 'absolute',
    },
    relative: {
      position: 'relative',
    },
    fixed: {
      position: 'fixed',
    },
  },

  // Z-index scale
  zIndex: {
    base: 1,
    dropdown: 10,
    sticky: 20,
    overlay: 30,
    modal: 40,
    notification: 50,
  },
};

// Responsive breakpoints (TV-focused)
export const breakpoints = {
  tv4K: '3840px',
  tvHD: '1920px',
  tvSD: '1280px',
  tablet: '768px',
  mobile: '480px',
};
